export default __webpack_public_path__ + "img/cYghomSJ.744998eb.svg";